import angular from "angular";
export class AppConstantService {
    static componentName = "AppConstant";

    Locales = {
        'locales': {
            'pl-PL': 'Pl',
            'en-US': 'En'
        },
        'preferredLocale': 'pl-PL'
    };
}

angular.module("topline.app").service(AppConstantService.componentName, AppConstantService);